import React from "react";
import Chip from "@material-ui/core/Chip";
import { upperCase } from "lodash";

interface IStatusField {
  title: string;
}

export const translateStatus = (status: string): string => {
  if (status) {
    if (status === "Payment") {
      status = "Split Payment";
    }

    if (status === "Schedule") {
      status = "Shared Schedule";
    }

    // make capital to all status
    return upperCase(status);
  }
};

const getColor = (text: string): string => {
  if (text) {
    switch (text) {
      case "Main Student":
      case "active":
        return "#4caf50";

      case "Shared Student":
        return "#1976d2";

      case "Payment":
        return "#ff9800";

      case "Schedule":
        return "#7c4dff";

      case "inactive":
        return "#f44336";

      default:
        return "#9e9e9e";
    }
  }
};

const CustomStatusField = ({ title }: IStatusField) => {
  const translated = translateStatus(title);
  const color = getColor(title);

  return (
    <div style={{ marginLeft: 5 }}>
      <Chip
        label={translated}
        style={{ backgroundColor: `${color}`, color: "#FFF" }}
      />
    </div>
  );
};

export default CustomStatusField;
